import { request } from "../utilities/axios-utils.js";

export const getAllQuestions = async (accessToken) => {
  try {
    // const azurAccessToken = getAzureJWTToken();
    const auraAllQuestionsResponse = await request({
      url: "/questions",
      method: "GET",
      accessToken: accessToken,
      headers: {
        "applicant-id": "1",
      },
    });
    return auraAllQuestionsResponse.data;
  } catch (error) {
    console.error("Error while get questions :", error);
  }
};

export const getAllOccupationOptions = async (
  inputValue,
  questionID,
  accessToken
) => {
  try {
    const response = await request({
      url: `/questions/${questionID}?search=${inputValue}`,
      method: "GET",
      accessToken: accessToken,
      headers: {
        "applicant-id": "1",
      },
    });
    return response?.data?.responseJson;
  } catch (error) {
    console.error("Error fetching options:", error);
  }
};

export const answerAuraQuestion = async (payload, accessToken) => {
  try {
    const response = await request({
      url: `/questions/${payload.id}`,
      method: "PATCH",
      data: payload,
      accessToken: accessToken,
      headers: {
        "applicant-id": "1",
        "If-Match": `${payload.etag}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching options:", error);
    throw new Error(error);
  }
};
